
export const ScanModes = {
    UNKNOWN: 0,
    ACCESS: 1,
    PRODUCT: 2,
    HISTORY: 3
};